// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f579da50","185":"4ed1e356","330":"a42f39e4","453":"96431f4b","491":"acbcaede","889":"5c48459c","909":"561d0c59","994":"f4a59395"}[chunkId] + ".chunk.js";
};